/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 08:59
 */
import Column from "./Column";

class BooleanColumn extends Column {

  constructor(params) {
    super(params);
    this.init();
  }

}

export default BooleanColumn;



// WEBPACK FOOTER //
// ./resources/assets/js/columns/BooleanColumn.js